/**
 * author by ff
 * date 2020-03-18
 */
import Vue from 'vue'
import App from './App.vue'

// 引入路由
// import router 的router 一定要小写， 不要写成Router, 否则报 can't match的报错
import router from "./router/router.js"
new Vue({
    el: '#app',
    data: {
        positionX: 0,
        positionY: 0,
    },
    router,  // 注入到根实例中
    render: h => h(App),
    directives: {
        drag: {
            // 指令的定义
            bind: function (el) {
                let odiv = el;  //获取当前元素
                oDiv.onmousedown = (e) => {
                    //算出鼠标相对元素的位置
                    let disX = e.clientX - odiv.offsetLeft;
                    let disY = e.clientY - odiv.offsetTop;

                    document.onmousemove = (e) => {
                        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                        let left = e.clientX - disX;
                        let top = e.clientY - disY;

                        //绑定元素位置到positionX和positionY上面
                        this.positionX = top;
                        this.positionY = left;

                        //移动当前元素
                        odiv.style.left = left + 'px';
                        odiv.style.top = top + 'px';
                    };
                    document.onmouseup = (e) => {
                        document.onmousemove = null;
                        document.onmouseup = null;
                    };
                };
            }
        }
    }
})

// new Vue({
//     el: '#app',
//     render: h => h(App)
// })

// import Vue from 'vue'
// import VueRouter from 'vue-router'

// Vue.use(VueRouter)

// const Home = { template: '<div>This is Home</div>' }
// const Foo = { template: '<div>This is Foo</div>' }
// const Bar = { template: '<div>This is Bar {{ $route.params.id }}</div>' }

// const router = new VueRouter({
//     mode: 'history',
//     base: __dirname,
//     routes: [
//         { path: '/', name: 'home', component: Home },
//         { path: '/foo', name: 'foo', component: Foo },
//         { path: '/bar/:id', name: 'bar', component: Bar }
//     ]
// })

// new Vue({
//     router,
//     template: `
//     <div id="app">
//       <h1>Named Routes</h1>
//       <p>Current route name: {{ $route.name }}</p>
//       <ul>
//         <li><router-link :to="{ name: 'home' }">home</router-link></li>
//         <li><router-link :to="{ name: 'foo' }">foo</router-link></li>
//         <li><router-link :to="{ name: 'bar', params: { id: 123 }}">bar</router-link></li>
//       </ul>
//       <router-view class="view"></router-view>
//     </div>
//   `
// }).$mount('#app')
